import React from "react";
import Entries from "./../Entries";
import { FormLayout } from "playground/cms/Form";
import ReviewForm from "./ReviewForm";
//import PropTypes from 'prop-types';

export function Reviews(props) {
    const {} = props;
    return (
        <Entries {...props}>
            <FormLayout>
                <FormLayout.Content prepend={true}>
                    <FormLayout.Tab id={"review"} label={"Opinia"}>
                        <ReviewForm {...props} />
                    </FormLayout.Tab>
                </FormLayout.Content>
            </FormLayout>
        </Entries>
    );
}

Reviews.propTypes = {};

Reviews.defaultProps = {};

export default Reviews;
